import type { ReactNode } from 'react';

export interface MoveCue {
  id: number;
  generation: number;
  to: string;
  correct: boolean;
}

/** Decoration around the existing board; never delays or changes a chess move. */
export function MoveFeedback({
  cue,
  orientation,
  reduced,
  children,
}: {
  cue?: MoveCue;
  orientation: 'white' | 'black';
  reduced: boolean;
  children: ReactNode;
}) {
  const file = cue ? cue.to.charCodeAt(0) - 97 : 0;
  const rank = cue ? Number(cue.to[1]) - 1 : 0;
  return (
    <div className="move-feedback">
      {children}
      {cue?.correct && !reduced && (
        <div className="move-feedback-grid" aria-hidden="true">
          <span
            key={cue.id}
            className="correct-move-ring"
            data-square={cue.to}
            style={{
              left: `${(orientation === 'white' ? file : 7 - file) * 12.5}%`,
              top: `${(orientation === 'white' ? 7 - rank : rank) * 12.5}%`,
            }}
          />
        </div>
      )}
    </div>
  );
}
